module.exports = __webpack_public_path__ + "static/img/wdhj1-3.a04d7ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdhj1-3.png
// module id = 866
// module chunks = 0